export type VerificationDocType =
  | 'operating_authority'
  | 'business_license'
  | 'w9'
  | 'surety_bond'
  | 'certificate_of_insurance'
  | 'unknown';

export const DOC_TYPE_LABELS: Record<VerificationDocType, string> = {
  operating_authority: 'Operating Authority (MC)',
  business_license: 'Business License',
  w9: 'IRS W-9',
  surety_bond: 'Surety Bond (BMC-84 / BMC-85)',
  certificate_of_insurance: 'Certificate of Insurance',
  unknown: 'Detecting…',
};

export const DOC_TYPE_HELP: Record<VerificationDocType, string> = {
  operating_authority: 'FMCSA Operating Authority granting MC number.',
  business_license: 'State or local business registration.',
  w9: 'IRS Form W-9 with EIN matching company record.',
  surety_bond: 'BMC-84 / BMC-85 surety bond ($75,000 minimum for brokers).',
  certificate_of_insurance: 'Cargo / liability insurance certificate. LaneRunner must be listed as Certificate Holder.',
  unknown: 'AI is identifying this document. Admin will tag it if needed.',
};

export type UserRole = 'broker' | 'carrier' | 'shipper' | 'broker_carrier';

// Doc types an admin may reassign an "unknown" document to.
export const ASSIGNABLE_DOC_TYPES: VerificationDocType[] = [
  'operating_authority',
  'w9',
  'surety_bond',
  'certificate_of_insurance',
  'business_license',
];
